export default __webpack_public_path__ + "static/media/defis.b1b36932.jpg";